import React, { useState } from 'react';
import { Trash2, XCircle, XOctagon } from 'react-feather';

interface Props {
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  submitting: boolean;
  error?: string | null;
  inputId: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: React.FC<Props> = ({
  title,
  message,
  confirmLabel,
  submitting,
  error,
  inputId,
  onCancel,
  onConfirm,
}) => {
  const [confirmation, setConfirmation] = useState('');

  const handleCancel = () => {
    if (submitting) return;
    onCancel();
  };

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="btn-close" onClick={handleCancel} disabled={submitting}>
            <XCircle size={18} />
          </button>
        </div>
        <div className="modal-form">
          <div className="delete-warning">
            <Trash2 size={18} />
            <div>
              <strong>This cannot be undone.</strong>
              <p>{message}</p>
            </div>
          </div>
          {error && <div className="error">{error}</div>}
          <div className="form-group">
            <label htmlFor={inputId}>Type <strong>delete</strong> to confirm</label>
            <input
              id={inputId}
              type="text"
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
              disabled={submitting}
              autoFocus
            />
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={submitting}
            >
              <XOctagon size={14} />
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onConfirm}
              disabled={submitting || confirmation !== 'delete'}
            >
              <Trash2 size={14} />
              {submitting ? 'Deleting...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
